module.exports = __webpack_public_path__ + "img/syukyaku-top-015.575ca254.jpg";